export default "__VITE_ASSET__CIhOg25G__"